var _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationImageDragNDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "illustration-image-drag-n-drop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13168",
    "data-name": "Group 13168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6518",
    "data-name": "Path 6518",
    d: "M53.119,11.84H10.881A2.881,2.881,0,0,0,8,14.721H8V49.279a2.881,2.881,0,0,0,2.881,2.881H53.119A2.881,2.881,0,0,0,56,49.279h0V14.72A2.882,2.882,0,0,0,53.119,11.84Zm.96,37.439a.96.96,0,0,1-.96.96H10.881a.96.96,0,0,1-.96-.96V14.72a.96.96,0,0,1,.96-.96H53.119a.96.96,0,0,1,.96.96Z",
    fill: "#ced4da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6519",
    "data-name": "Path 6519",
    d: "M50.239,16.64H13.761a.96.96,0,0,0-.96.96V46.4a.96.96,0,0,0,.96.96H50.239a.96.96,0,0,0,.96-.96V17.6a.96.96,0,0,0-.96-.96Zm-.961,1.92V36.8H43.917l-8.358-8.357a.959.959,0,0,0-1.236-.1l-6.332,4.525-4.948-4.455a.96.96,0,0,0-1.175-.085l-7.147,4.762V18.56ZM14.72,45.438V38.719H22.4a.96.96,0,1,0,0-1.92H14.721V35.393l7.591-5.061,9.046,8.141a.96.96,0,1,0,1.291-1.421l-.006-.006-3.19-2.87,5.323-3.8L41.2,36.8H37.76a.96.96,0,0,0,0,1.92H49.278v6.72Z",
    fill: "#ced4da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6520",
    "data-name": "Path 6520",
    d: "M43.52,28.16a3.84,3.84,0,1,0-3.84-3.84h0A3.84,3.84,0,0,0,43.52,28.16Zm0-5.76a1.92,1.92,0,1,1-1.92,1.92,1.92,1.92,0,0,1,1.92-1.92Z",
    fill: "#ced4da"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17640",
    "data-name": "Rectangle 17640",
    width: 64,
    height: 64,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationImageDragNDrop);
export default __webpack_public_path__ + "static/media/illustration-image-drag-n-drop.9c8c0e24047563092aeb4a2353fb5004.svg";
export { ForwardRef as ReactComponent };